const useCustomWidthStyle = ({
  containerData,
  isMobile,
  width
}) => {
  var _a, _b;
  return ((_a = containerData == null ? void 0 : containerData.width) == null ? void 0 : _a.size) === "ORIGINAL" || isMobile && (Number((_b = containerData == null ? void 0 : containerData.width) == null ? void 0 : _b.custom) || 0) > 150 ? { width: width != null ? width : "0px", maxWidth: "100%" } : {};
};
export {
  useCustomWidthStyle
};
//# sourceMappingURL=use-custom-width-style.js.map
